import { LabelWithTip } from "./InfoTip";
import styles from "./MetricCard.module.css";

function TrendArrow({ direction }) {
  if (direction === "neutral") {
    return null;
  }

  return (
    <span
      className={`${styles.trendArrow} ${direction === "up" ? styles.trendUp : styles.trendDown}`}
      aria-hidden="true"
    />
  );
}

export default function MetricCard({ label, value, detail, info, trend = "neutral" }) {
  return (
    <article className={styles.card}>
      <p className={styles.label}>
        {info ? <LabelWithTip label={label} text={info} /> : label}
      </p>
      <p className={styles.value}>{value}</p>
      {detail ? (
        <p
          className={`${styles.detail} ${
            trend === "up" ? styles.detailUp : trend === "down" ? styles.detailDown : ""
          }`}
        >
          <TrendArrow direction={trend} />
          <span>{detail}</span>
        </p>
      ) : null}
    </article>
  );
}
